const state = {
  employeeList: [], // 员工数据列表
  selectedPosition: [], // 筛选的职位
  currentSubscript: [{ postName: '全部' }] // 存储用户所选择的职位列表 默认为全部
}

const mutations = {
  // 存储员工职位列表
  storeJobInformation(state, positionData) {
    /**
     * ${ positionData } positionData 职位信息
     * * currentJobInformation 当前员工数据
     * * allEmployeeList 所有员工数据
     * */
    const { currentJobInformation, allEmployeeList } = positionData
    let newEmployeeJobListings = [] // 新的员工职位列表

    // employeeNo 员工工号
    currentJobInformation.forEach((curretItem) => {
      // currentEmployeeNo 当前员工工号
      const { employeeNo: currentEmployeeNo } = curretItem
      // 查询信息
      allEmployeeList.forEach((allItem) => {
        // 所有员工数据中的工号信息
        const { employeeNo: allEmployeeNo, postName } = allItem

        // 判断当前员工工号是否等于所有员工数据中的工号信息
        if (currentEmployeeNo === allEmployeeNo) {
          // 存储这个工号的职位数据到当前员工数据中
          this._vm.$set(curretItem, 'postName', postName)

          newEmployeeJobListings.push(curretItem)
        }
      })
    })

    let employeeInformation = [] // 所有员工信息

    newEmployeeJobListings.forEach((item) => {
      let mark = true
      employeeInformation.forEach((newItem) => {
        if (item.postName === newItem.postName) mark = false
      })
      if (mark) employeeInformation.push({ ...item, numberOfJobsIndex: 0 })
    })

    // 获取所有员工信息 职位 姓名 工号
    let employeeInformationLiet = []
    let arr = newEmployeeJobListings.map((item) => ({
      postName: item.postName,
      employeeNo: item.employeeNo,
      employeeName: item.employeeName
    }))

    arr.forEach((item) => {
      const { employeeNo, employeeName } = item
      let mark = true
      employeeInformationLiet.forEach((newItem) => {
        if (employeeName === newItem.employeeName && employeeNo === newItem.employeeNo) mark = false
      })

      if (mark) employeeInformationLiet.push(item)
    })

    employeeInformationLiet.forEach((newItem) => {
      employeeInformation.forEach((item) => {
        if (newItem.postName === item.postName) {
          item.numberOfJobsIndex++
        }
      })
    })

    state.selectedPosition = employeeInformation.sort((a, b) => {
      return b.numberOfJobsIndex - a.numberOfJobsIndex
    })
  },
  // 更新下表状态
  updateTableStatus(state, item) {
    // 判断是添加还是删除
    let subscript = -1
    const { postName } = item
    state.currentSubscript.forEach((item, index) => {
      if (item.postName === postName) subscript = index
    })

    if (subscript === -1) state.currentSubscript.push(item)
    else state.currentSubscript.splice(subscript, 1)

    // 判断职位是 大于一条 小于一条
    if (state.currentSubscript.length > 1) {
      if (state.currentSubscript[0].postName === '全部') {
        state.currentSubscript.splice(0, 1)
      }
    } else if (state.currentSubscript.length === 0) {
      state.currentSubscript.push({ postName: '全部' })
    }
  },
  // 计算员工数据展示列表
  employeeDataDisplayList(state, currentEmployeeData) {
    const { currentSubscript } = state
    console.log('员工数据', currentEmployeeData) // 当前员工数据
    console.log(currentSubscript)

    let newData = []
    if (currentSubscript[0].postName === '全部') {
      newData = currentEmployeeData
    } else {
      currentSubscript.forEach((filterItem) => {
        const { postName: filterPostName } = filterItem
        currentEmployeeData.forEach((item) => {
          if (item.postName === filterPostName) newData.push(item)
        })
      })
    }

    let OpenCardFillingArr = []

    // 判断当前数据是否为充值开卡数据
    if (newData[0].isOpenCardFilling) {
      newData.forEach((item, index) => {
        OpenCardFillingArr.push(item)
        OpenCardFillingArr.push({
          cardType: '次卡',
          isOpenCardFilling: true, // 重开卡标识
          performance: item.timeCardBrokerage,
          singular: item.timeCardCount
        })
        OpenCardFillingArr.push({
          cardType: '折扣卡',
          isOpenCardFilling: true, // 重开卡标识
          performance: item.discountCardBrokerage,
          singular: item.discountCardCount
        })
      })
    }

    state.employeeList = OpenCardFillingArr.length ? OpenCardFillingArr : newData
  },
  // 清空职位列表数据
  clearJobInformation(state) {
    state.currentSubscript = [{ postName: '全部' }]
    state.selectedPosition = []
  }
}

const getters = {
  jobListings(state) {
    const { currentSubscript } = state
    let newArray = []
    currentSubscript.forEach((item) => {
      newArray.push(item.postName)
    })
    return newArray
  }
}
export default {
  namespaced: true, // 开启映射
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/home/data/data.js